import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function NavbarBreadcrumbs({ sucursal_id, profile }) {
  const sucursales = profile.sucursales;
  const sucursal = sucursales?.find(
    sucursal => sucursal.sucursal_id === sucursal_id,
  );

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}>
      <Typography
        variant="body1"
        sx={{ color: 'text.primary', fontWeight: 'normal' }}>
        Dashboard
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'text.primary', fontWeight: sucursal ? 'normal' : 600 }}>
        Estadísticas generales
      </Typography>
      {sucursal && (
        <Typography
          variant="body1"
          sx={{ color: 'text.primary', fontWeight: 600 }}>
          {sucursal.sucursal_name}
        </Typography>
      )}
    </StyledBreadcrumbs>
  );
}
